<template>
    <div :class="{ editDocumentStandalone: !inModal }">




        <div class="quillEditorToolbarWrapper"
             :style="inModal ? '' : 'position:sticky;top:90px;width:1120px;margin:0 auto;z-index:99'">
            <div style="position:relative;top:2px">


                <div class="card"
                     v-if="!inModal"
                     style="position:absolute;top:-4px;width:1120px;left: 1px;height:42px;">


                    <div>

                        <input v-if="!uniqueForEvent"
                               id="documentNameInput"
                               style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width:128px;position:relative;float:left;left:0;top:5px;border:none;border-right:solid 1px #ccced1;border-radius:0;padding-top:3px;padding-bottom:3px"
                               class="form-control"
                               v-model="document.name"
                               @focus="hideToolbar = true;"
                               @blur="hideToolbar = false; updateName()">


                        <button v-show="hideToolbar"
                                v-if="!uniqueForEvent"
                                class="btn btn-xs btn-primary"
                                style="position:relative;font-size:14px;top:13px;">
                            שנה שם
                        </button>





                        <button v-show="!hideToolbar"
                                v-if="!uniqueForEvent"
                                class="btn btn-xs btn-primary"
                                @click="saveDocument()"
                                style="position:relative;float:right;right:12px;top:9px;font-size:14px;padding-left:12px;padding-right:12px">
                            שמור
                        </button>

                        <button v-show="!hideToolbar"
                                v-if="!uniqueForEvent"
                                class="btn btn-xs btn-primary"
                                @click="printDocument()"
                                style="position:relative;float:right;right:22px;top:9px;font-size:14px;padding-left:12px;padding-right:12px">
                            הדפס
                        </button>

                        <button v-show="!hideToolbar"
                                v-if="document && document.id && customerId"
                                class="btn btn-xs btn-outline-primary"
                                @click="$emit('sendForSigning')"
                                style="position:relative;float:right;right:32px;top:9px;font-size:14px;padding-left:12px;padding-right:12px">
                            <i class="fa-regular fa-share-from-square"></i>
                            שלח לחתימה
                        </button>

                        <button v-show="!hideToolbar"
                                v-if="document && document.id && customerId"
                                class="btn btn-xs btn-outline-primary"
                                @click="$emit('signInPlace')"
                                style="position:relative;float:right;right:42px;top:9px;font-size:14px;padding-left:12px;padding-right:12px">
                            <i class="fa-solid fa-pen-clip"></i>
                            חתימה במקום
                        </button>

                    </div>

                </div>
            </div>
        </div>


        <!-- template classification + {{parameters}} bar, standalone page only.
             filled tokens are resolved when the template is applied to a meeting/customer/event -->
        <div v-if="!inModal"
             class="documentSettingsBar card">

            <div class="documentSettingsField">
                <label>סוג מסמך</label>
                <Multiselect label="name"
                             v-model="groupName"
                             :allow-empty="true"
                             deselectLabel=""
                             selectedLabel=""
                             placeholder="ללא סיווג"
                             track-by="groupName"
                             selectLabel=""
                             :options="$handlers.documentsHandler.documentGroups">
                    <template slot="noResult">לא נמצאו תוצאות</template>
                    <template slot="noOptions">אין אפשרויות</template>
                </Multiselect>
            </div>

            <div class="documentSettingsField">
                <label>סוג אירוע</label>
                <Multiselect label="name"
                             v-model="eventClass"
                             :allow-empty="true"
                             deselectLabel=""
                             selectedLabel=""
                             placeholder="ללא סיווג"
                             track-by="id"
                             selectLabel=""
                             :options="$store.state.eventClasses">
                    <template slot="noResult">לא נמצאו תוצאות</template>
                    <template slot="noOptions">אין אפשרויות</template>
                </Multiselect>
            </div>

            <div class="documentSettingsField documentSettingsTags">
                <label>תגיות</label>
                <Multiselect v-model="tags"
                             :options="allTagOptions"
                             :multiple="true"
                             :taggable="true"
                             @tag="addTag"
                             deselectLabel=""
                             selectedLabel=""
                             selectLabel=""
                             placeholder="למשל: השכרת שמלה, מכירת שמלה"
                             tagPlaceholder="הקישו אנטר ליצירת תגית חדשה">
                    <template slot="noResult">לא נמצאו תוצאות</template>
                    <template slot="noOptions">אין אפשרויות</template>
                </Multiselect>
            </div>

            <div class="documentSettingsField documentSettingsParams">
                <label>פרמטרים</label>

                <span class="addTemplateFieldLink"
                      @click="$refs.templateFieldsPopup.toggle()">
                    <i class="fa-solid fa-plus"
                       style="position:relative;top:1px"></i>
                    הוסף פרמטר
                </span>

                <TemplateFieldsPopup ref="templateFieldsPopup"
                                     style="position:absolute;top:70px;left:0;z-index:200"
                                     :sections="templateFieldSections"
                                     @insert="insertTemplateField"></TemplateFieldsPopup>
            </div>

        </div>


        <CkEditor ref="ckEditor"
                  @ready="editorIsReady()"
                  :class="{ hideToolbar, inModal }"></CkEditor>

    </div>
</template>
<script>

import Multiselect from "vue-multiselect";
import DocumentsHandler from "../../modules/DocumentsHandler";
import TemplateFieldsHandler from "../../modules/TemplateFieldsHandler";
import TemplateFieldsPopup from "../Common/TemplateFieldsPopup.vue";
import CkEditor from "./CkEditor.vue";

export default {
    name: 'EditDocument',
    methods: {

        //lets parents (e.g. PlanupMeetingForm) push text into the editor at the caret
        insertText(text) {
            this.$refs.ckEditor.insertText(text);
        },


        insertTemplateField(field) {
            this.insertText('{{' + field + '}}');
        },


        addTag(newTag) {
            this.tags.push(newTag);
        },


        //load the document's classification into the pickers. called on mount as well as
        //on prop change - parents that resolve the document before rendering us (the
        //standalone page) never fire the watcher
        applyDocument() {

            if (!this.document)
                return;

            this.chosenDocumentOriginalNameBeforeEdits = this.document.name;

            let group = this.$handlers.documentsHandler.documentGroups.find(x => x.groupName == this.document.groupName);
            let eventClass = this.$store.state.eventClasses.find(x => x.id == this.document.eventClassId);

            //a lookup miss (hidden or removed event class) must not null out the value the
            //document already carries - the pickers write back through their watchers
            if (group || !this.document.groupName)
                this.groupName = group || null;

            if (eventClass || !this.document.eventClassId)
                this.eventClass = eventClass || null;

            this.tags = this.document.tags || [];
        },


        printDocument() {

            document.querySelector('#showOnlyForPrint').innerHTML = this.$refs.ckEditor.getData();

            print();

        },


        getDocumentAfterEdits() {
            return this.$refs.ckEditor.getData();
        },


        updateName() {


            if (this.document.name == this.chosenDocumentOriginalNameBeforeEdits)
                return;

            this.$swal({
                title: 'האם לעדכן את שם המסמך?',
                text: 'המסמך ' + '"' + this.chosenDocumentOriginalNameBeforeEdits + '" יקרא מעכשיו "' + this.document.name + '".',
                confirmButtonText: 'שמור',
                cancelButtonText: 'ביטול',
                confirmButtonColor: '#ab8ce4',
                showCancelButton: true,

            }).then(result => {

                DocumentsHandler.updateName(this.document);
                this.chosenDocumentOriginalNameBeforeEdits = this.document.name;

            }).catch(error => {
                this.document.name = this.chosenDocumentOriginalNameBeforeEdits;
            })

        },


        saveDocument() {

            this.$swal({
                title: 'האם לשמור שינויים?',
                text: 'השינויים החדשים יחליפו את התוכן הקיים במסמך "' + this.document.name + '".',
                confirmButtonText: 'שמור',
                cancelButtonText: 'ביטול',
                confirmButtonColor: '#ab8ce4',
                showCancelButton: true,

            }).then((result) => {


                this.$html2canvas(this.$el.querySelector('.ck-content'), { scale: 0.4 }).then(

                    canvas => {

                        this.document.previewImage = canvas.toDataURL();
                        this.document.content = this.$refs.ckEditor.getData();

                        this.document.isTemplate = true;

                        //a nameless template renders as a blank row in every template
                        //picker, which reads as "there are no templates"
                        if (!this.document.name || !this.document.name.trim())
                            this.document.name = 'מסמך חדש';

                        // a parent that handles afterSave shows its own success message — skip the generic toast
                        DocumentsHandler.saveDocument(this.document, !!this.onAfterSave).then((document)=>{

                            if (this.onAfterSave) {
                                this.onAfterSave(document);
                            } else if (!this.noRedirect) {
                                this.$router.push(`/document/?id=${document.id}`);
                            }

                        })

                    
                    }

                )


            }).catch(error => {

            })

        },


        editorIsReady() {

            if (this.document?.content) {

                this.$refs.ckEditor.setData(this.document.content);

            }

        }

    },

    props: ['document', 'uniqueForEvent', 'inModal', 'startMinimized', 'noRedirect', 'onAfterSave', 'customerId'],

    data() {

        return {

            eventClass: null,
            groupName: null,
            tags: (this.document && this.document.tags) || [],
            chosenDocumentOriginalNameBeforeEdits: this.document?.name,
            hideToolbar: false,
        }
    },

    computed: {

        isMeetingSummary() {
            return (this.groupName && this.groupName.groupName == 'meetingSummary')
                || (this.document && this.document.groupName == 'meetingSummary');
        },

        templateFieldSections() {

            let sections = [];

            if (this.isMeetingSummary)
                sections.push({ title: 'פגישה', fields: TemplateFieldsHandler.meetingFields });

            sections.push({ title: 'אירוע', fields: TemplateFieldsHandler.eventFields });
            sections.push({ title: 'לקוח', fields: TemplateFieldsHandler.customerFields });
            sections.push({ title: 'כללי', fields: TemplateFieldsHandler.generalFields });

            return sections.concat(TemplateFieldsHandler.bookingFieldSections());
        },

        //every tag ever used on a template, so existing tags are suggested instead of retyped
        allTagOptions() {

            let store = this.$store.state.documents || {};

            let allTemplates = [].concat(
                store.meetingSummaryTemplates || [],
                store.termsTemplates || [],
                store.generalTemplates || []
            );

            let options = [];

            allTemplates.forEach(template => (template.tags || []).forEach(tag => {
                if (!options.includes(tag))
                    options.push(tag);
            }));

            (this.tags || []).forEach(tag => {
                if (!options.includes(tag))
                    options.push(tag);
            });

            return options;
        },
    },

    watch: {

        document: function () {

            this.applyDocument();

            if (this.document.content && this.document.content.length)
                this.$refs.ckEditor?.setData(this.document?.content)

        },

        groupName(newVal) {
            this.document.groupName = newVal ? newVal.groupName : null;
        },


        eventClass(newVal){

            this.document.eventClassId = newVal ? newVal.id : null;
        },


        tags(newVal) {
            this.document.tags = newVal;
        }

    },

    mounted() {

        this.applyDocument();

    },

    components: { CkEditor, Multiselect, TemplateFieldsPopup }

}
</script>
<style>
.editDocumentStandalone {
    position: relative;
}

/* second header row: classification + parameters. absolute so it doesn't push the
   sticky name/save bar out of alignment with the ck toolbar; scrolls away with the page */
.documentSettingsBar {
    position: absolute;
    top: 60px;
    left: 50%;
    transform: translateX(-50%);
    width: 1120px;
    z-index: 50;
    display: flex;
    flex-direction: row; /* .card sets column */
    align-items: flex-end;
    gap: 20px;
    padding: 10px 16px 12px;
    margin-bottom: 0;
}

.documentSettingsField {
    width: 190px;
}

.documentSettingsField > label {
    display: block;
    font-size: 12px;
    color: #999;
    margin-bottom: 3px;
    user-select: none;
}

.documentSettingsTags {
    flex: 1;
    min-width: 280px;
}

.documentSettingsParams {
    position: relative;
    width: 130px;
}

.addTemplateFieldLink {
    display: inline-block;
    color: #ab8ce4;
    cursor: pointer;
    user-select: none;
    white-space: nowrap;
    padding: 8px 0;
}

/* make room for the settings bar between the toolbar and the page */
.editDocumentStandalone .ck-editor__editable_inline {
    margin-top: 110px;
}

.inModal .ck-editor__top {
    width: calc(100% - 2px) !important;
    padding: 0 !important;
    border: solid 1px #ced4da;
    top: 0 !important;
    position: relative !important;
    margin-bottom: 0 !important;
    border-radius: 6px 6px 0 0 !important;
    margin-top: 0 !important;
    border-right: none !important;
    border-left: none !important;
}

.inModal .ck-toolbar {
    border-radius: 6px !important;
}

.inModal .ck-editor__top button {
    /* margin-right: 1px !important; */
    margin-right: unset !important;
    flex: 1 !important
}

.inModal .ck-toolbar__separator {
    margin-right: unset !important;
    flex: 0 !important
}

.inModal .ck-editor__editable_inline {
    width: 100% !important;
}

.inModal .ck-content {
    aspect-ratio: unset !important;
    height: 250px !important;
    margin-top: 6px !important;
    background: rgb(246, 247, 251) !important;
}
</style>